import styled from 'styled-components';

export const LogoButton = styled.a`
  position: absolute;
  top: 30px;
  right: 25px;
  z-index: 2;
  border-radius: 10px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  padding: 10px 5px 0px 5px;
  background-color: #fff;
`;

export const ContactButton = styled.a`
  position: absolute;
  bottom: 40px;
  right: 50px;
  z-index: 2;
  height: 60px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.25);
  border-radius: 50%;
`;
